<template>
  <el-drawer
    title="详情"
    :visible.sync="drawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="50%"
    withHeader="false"
  >
    <div class="flex flex-align-center margin-bottom-20">
      <div class="title-box" style="margin-bottom: 0">基本信息</div>
      <el-button type="primary" @click="lookActive(info.id)" size="mini" style="margin-left: 10px"
        >预览</el-button
      >
    </div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="活动状态">
        <div>{{ info.activeStatus }}</div>
      </el-descriptions-item>
      <el-descriptions-item label="活动类型">
        <el-table
          :data="info.typeList"
          border
          size="mini"
          max-height="280px"
          style="margin: 0 10px; width: 500px"
        >
          <el-table-column label="活动类型" prop="typeName" align="center" />
          <el-table-column label="参与条件" align="center" prop="conditions" />
          <el-table-column label="有效线路" align="center" prop="lineName" v-if="info.type !== 1" />
          <el-table-column label="限制参与用户" align="center" prop="restrictedUser" />
        </el-table>
      </el-descriptions-item>
      <el-descriptions-item label="活动名称">
        <div>{{ info.name }}</div>
      </el-descriptions-item>
      <el-descriptions-item label="活动时间"
        >{{ info.startTime }} 至 {{ info.endTime }}</el-descriptions-item
      >
      <el-descriptions-item label="活动规则">
        <div v-html="info.description"></div>
      </el-descriptions-item>
      <el-descriptions-item label="活动链接">
        <div class="flex-col">
          <div class="flex flex-align-center">
            <div class="url-box">
              {{ '/pages/user/prizeDraw/index?goIndex=1&activeId=' + info.id }}
            </div>

            <el-button
              type="primary"
              @click="copyUrl('/pages/user/prizeDraw/index?goIndex=1&activeId=' + info.id)"
              size="mini"
              style="margin-left: 10px"
              >复制</el-button
            >
          </div>
          <div class="margin-top-10">
            <vue-qr :logoScale="0.2" :logoMargin="1" :text="qrCode" :margin="0" :size="80" />
            <div>微信扫码直达活动页面</div>
            <div>渠道链接:{{ qrCode }}</div>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <template v-if="info.type !== 4">
      <div class="title-box">页面样式</div>
      <el-descriptions :column="1" style="margin-left: 40px">
        <el-descriptions-item label="页面头图">
          <el-image
            :src="info.images"
            style="width: 120px; margin-left: 30px"
            :preview-src-list="[info.images]"
          />
        </el-descriptions-item>
        <el-descriptions-item label="页面背景色">{{ info.backgroundColor }}</el-descriptions-item>
      </el-descriptions>
    </template>
    <div class="title-box">活动奖品</div>
    <el-table :data="info.prizes" border size="mini" max-height="280px" style="margin: 0 10px">
      <el-table-column label="序号" type="index" width="50" align="center" />
      <el-table-column label="奖品名称" align="center" prop="prizeName" />
      <el-table-column label="奖品数量（已中奖量/奖品库存量）" align="center">
        <template slot-scope="scope">
          {{ scope.row.winNumbers }}/{{ scope.row.stockNumbers }}
        </template>
      </el-table-column>
      <el-table-column label="中奖概率" align="center" prop="winnerRate">
        <template slot-scope="scope"> {{ scope.row.winnerRate }}</template>
      </el-table-column>
      <el-table-column label="排序" align="center" prop="sort" />
    </el-table>
    <div class="title-box margin-top-20">分享信息</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="标题">{{ info.shareTitle }}</el-descriptions-item>
      <el-descriptions-item label="分享图">
        <el-image
          :src="info.shareImages"
          style="width: 120px; margin-left: 30px"
          :preview-src-list="[info.shareImages]"
        />
      </el-descriptions-item>
    </el-descriptions>

    <div class="title-box">其他</div>
    <div class="bottom-box">
      <el-descriptions :column="1" style="margin-left: 40px">
        <el-descriptions-item label="创建人">{{ info.createUser }}</el-descriptions-item>
        <el-descriptions-item label="操作人">{{ info.updateUser }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="1">
        <el-descriptions-item label="创建时间">{{ info.createTime }}</el-descriptions-item>
        <el-descriptions-item label="操作时间">{{ info.updateTime }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
  import { copyText } from '@/util/util'
  import { raffleDetail } from '@/api/marketing/prize-draw'
  const statusList = [
    { value: 0, label: '待上架' },
    { value: 1, label: '未开始' },
    { value: 2, label: '进行中' },
    { value: 3, label: '已结束' },
    { value: -1, label: '已下架' }
  ]
  export default {
    data() {
      return {
        drawer: false,
        info: {
          url: ''
        },
        rowCenter: {
          'text-align': 'center'
        },
        qrCode: ''
      }
    },
    methods: {
      init(id) {
        this.advertisingId = id
        this.getInfoFetch(id)
      },
      getInfoFetch(id) {
        this.$loading()
        raffleDetail(id)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              data.typeList = this.getTypeList(data)
              const obj = statusList.filter((item) => item.value === data.status)
              data.activeStatus = obj[0].label
              data.prizes.forEach((item) => {
                item.winnerRate = item.winnerRate.toFixed(2) + '%'
              })
              this.info = data
              this.qrCode =
                process.env.NODE_ENV === 'production'
                  ? 'https://custom.ayundi.cn/prize-draw?activeId=' + data.id + '&goIndex=1'
                  : 'https://custom-dev.ayundi.cn/prize-draw?activeId=' + data.id + '&goIndex=1'
              this.drawer = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleClose() {
        this.title = ''
        this.info = {}
        this.drawer = false
      },
      // 复制链接
      async copyUrl(url) {
        await copyText(url)
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      },
      lookActive(id) {
        // 预览活动
        this.$emit('lookActive', id)
      },
      getTypeList(value) {
        const { conditions, type, typeName } = value
        const obj = conditions && JSON.parse(conditions)
        const arr = [
          {
            type,
            typeName,
            restrictedUser:
              obj.restrictedPhoneList && obj.restrictedPhoneList.length
                ? obj.restrictedPhoneList.join(',')
                : '-',
            lineName:
              obj.allowedLineList && obj.allowedLineList.length
                ? obj.allowedLineList.map((item) => item.name).join(';')
                : '全部线路'
          }
        ]
        if (type === 1) {
          arr[0].conditions = `${obj.allowedPeriod === 1 ? '活动期间' : '每天'}\n每人可参与${
            obj.allowedCountPerUser
          }次`
        } else if (type === 2) {
          arr[0].conditions = `每人完成${obj.ordersPerCompleted}单可参与${obj.allowedCount}次`
        } else if (type === 3) {
          arr[0].conditions = `完成首单乘车订单可参与${obj.firstOrderAllowedCount}次`
        } else if (type === 4) {
          arr[0].conditions = '-'
        }
        return arr
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    margin: 0 0 20px 20px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .bottom-box {
    display: flex;
  }

  .descriptions-text {
    text-align: left;
    font-weight: 400;
    line-height: 1.5;
    font-size: 14px;
    margin-left: 40px;
    margin-bottom: 10px;
  }
  .url-box {
    color: #409eff;
    width: 380px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ::v-deep .el-descriptions-item__container {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-descriptions-item__container {
    align-items: baseline !important;
  }
</style>
